import ContractListServices from '@/views/ContractList/ContractListServices';
import {
  APPLY_FILTERS,
  SET_ITEMS,
} from './types';

export default {
  applyFilter({ commit }, filters) {
    commit(APPLY_FILTERS, filters);
  },
  async getContractList({ commit, state }) {
    const { items, total } = await ContractListServices.getContractList({
      ...state.filters,
      active: true
    });

    commit(SET_ITEMS, { items, total });
  },
};
